const truncationSymbol = '…';

export function splitLabelByWords(text: string, limitPerLine: number, maxChars: number): string[] {
  const words = text.split(' ');
  const lines: string[] = [];
  let currentLine = '';
  let totalChars = 0;

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    if (currentLine.length && currentLine.length + word.length > limitPerLine * 1.5) {
      lines.push(currentLine);
      totalChars += currentLine.length;
      currentLine = '';
    }

    currentLine += (currentLine ? ' ' : '') + word;

    if (currentLine.length >= limitPerLine) {
      lines.push(currentLine);
      totalChars += currentLine.length;
      currentLine = '';
    }

    if (totalChars + currentLine.length >= maxChars) {
      if (currentLine) {
        lines.push(currentLine);
      }

      const allLength = lines.reduce((allChars, currentValue) => allChars + currentValue.length, 0);
      const rawLastLineLength = lines[lines.length - 1].length;

      let lastLineNewLength = maxChars - (allLength - rawLastLineLength);

      if (lastLineNewLength < limitPerLine - truncationSymbol.length) {
        lastLineNewLength = limitPerLine - truncationSymbol.length;
      }

      if (i === words.length - 1 && lastLineNewLength >= rawLastLineLength) {
        return lines;
      }

      lines[lines.length - 1] = lines[lines.length - 1].slice(0, lastLineNewLength - 1).trim() + truncationSymbol;

      return lines;
    }
  }

  if (currentLine) lines.push(currentLine);

  return lines;
}

export function splitTextByLines(text: string, lineLimit: number, maxLines?: number): string[] {
  const trimText = text.trim();
  const lines: string[] = [];

  const minCharactersInLine = lineLimit * 0.5;
  const maxCharactersInWord = lineLimit * 1.2;

  if (!trimText) return lines;

  const words = text.split(/\s+/);

  let activeLine = '';

  words.forEach(word => {
    if (!word.trim()) return;

    const probLine = activeLine ? `${activeLine} ${word}` : word;

    if (probLine.length > lineLimit) {
      // check if word is to big for one line
      if (activeLine.length < minCharactersInLine && word.length > maxCharactersInWord) {
        const freeNumberOfCharactersInLine = lineLimit - activeLine.length + 1;
        const firstPartOfWord = word.slice(0, freeNumberOfCharactersInLine - 1);
        const nextRowPartOfRow = word.slice(freeNumberOfCharactersInLine - 1);

        activeLine = `${activeLine} ${firstPartOfWord}`;

        lines.push(activeLine);
        activeLine = nextRowPartOfRow;
      } else {
        lines.push(activeLine);

        if (word.length < maxCharactersInWord) {
          activeLine = word;
        } else {
          splitWordByLength(word, lineLimit).forEach((wordPart, i, all) => {
            if (i === all.length - 1) {
              activeLine = wordPart;
              return;
            }

            lines.push(wordPart);
          });
        }
      }

      return;
    }

    activeLine = probLine;
  });

  if (activeLine) {
    lines.push(activeLine);
    activeLine = '';
  }

  if (!maxLines || lines.length <= maxLines) return lines;

  const slicedList = lines.slice(0, maxLines);

  const lastRowLength = slicedList[slicedList.length - 1].length;

  if (lastRowLength < lineLimit - 1) {
    const extraTextFromNextLine = lines[slicedList.length].slice(0, lineLimit - 1 - lastRowLength - 1);

    slicedList[slicedList.length - 1] = `${slicedList[slicedList.length - 1]} ${extraTextFromNextLine}`;
  }

  const lastLineWithTruncationSymbol = slicedList[slicedList.length - 1] + truncationSymbol;

  slicedList[slicedList.length - 1] = lastLineWithTruncationSymbol;

  return slicedList;
}

function splitWordByLength(word: string, partLength: number): string[] {
  if (!word || partLength <= 0) return [];

  const parts: string[] = [];
  for (let i = 0; i < word.length; i += partLength) {
    parts.push(word.slice(i, i + partLength));
  }

  return parts;
}
